import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: 'input[type=file][formControlName],input[type=file][formControl],input[type=file][ngModel]',
  // providers:[DefaultValueAccessor],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FileControlValueAccessorDirective,
      multi: true
    }
  ]
})
export class FileControlValueAccessorDirective implements ControlValueAccessor {

  constructor(private renderer: Renderer2, private host: ElementRef<HTMLInputElement>) {
  }
  
  private file: File | null = null;
  onChange: Function = (value:any) => {};
  onTouched: Function = () => {};

  @HostListener('change', ['$event.target.files'])
  emitFiles(event: FileList) {
    const file = event && event.item(0);
    this.onChange(file);
    this.file = file;
  }

  @HostListener('blur')
  emitTouched(event: FileList) {
    this.onTouched();
  }

  writeValue(obj: any): void {
    this.host.nativeElement.value = '';
    this.file = null;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched= fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.renderer.setProperty(this.host.nativeElement, 'disabled', isDisabled);
  }

}
